module.exports = __webpack_public_path__ + "GoSurferAfter.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GoSurferAfter.jpg
// module id = 844
// module chunks = 0